"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._CachedReadableLiquity = void 0;
/** @internal */
class _CachedReadableLiquity {
    constructor(readable, cache) {
        this._readable = readable;
        this._cache = cache;
    }
    async getTotalRedistributed(assetAddress, ...extraParams) {
        var _a;
        return ((_a = this._cache.getTotalRedistributed(assetAddress, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getTotalRedistributed(assetAddress, ...extraParams));
    }
    async getTroveBeforeRedistribution(assetAddress, address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getTroveBeforeRedistribution(assetAddress, address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getTroveBeforeRedistribution(assetAddress, address, ...extraParams));
    }
    async getTrove(assetAddress, address, ...extraParams) {
        // address is user wallet address
        const [troveBeforeRedistribution, totalRedistributed] = await Promise.all([
            this.getTroveBeforeRedistribution(assetAddress, address, ...extraParams),
            this.getTotalRedistributed(assetAddress, ...extraParams)
        ]);
        return troveBeforeRedistribution.applyRedistribution(totalRedistributed);
    }
    async getNumberOfTroves(assetAddress, ...extraParams) {
        var _a;
        return ((_a = this._cache.getNumberOfTroves(assetAddress, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getNumberOfTroves(assetAddress, ...extraParams));
    }
    async getPrice(assetAddress, ...extraParams) {
        var _a;
        return (_a = this._cache.getPrice(assetAddress, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getPrice(assetAddress, ...extraParams);
    }
    async getTotal(assetAddress, ...extraParams) {
        var _a;
        return (_a = this._cache.getTotal(assetAddress, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getTotal(assetAddress, ...extraParams);
    }
    async getStabilityDeposit(spAddress, address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getStabilityDeposit(spAddress, address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getStabilityDeposit(spAddress, address, ...extraParams));
    }
    async getSLSDInStabilityPool(spAddress, ...extraParams) {
        var _a;
        return ((_a = this._cache.getSLSDInStabilityPool(spAddress, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getSLSDInStabilityPool(spAddress, ...extraParams));
    }
    async getAssetBalance(assetAddress, address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getAssetBalance(assetAddress, address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getAssetBalance(assetAddress, address, ...extraParams));
    }
    async getAssetAllowance(assetAddress, address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getAssetAllowance(assetAddress, address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getAssetAllowance(assetAddress, address, ...extraParams));
    }
    async getSLSDBalance(address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getSLSDBalance(address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getSLSDBalance(address, ...extraParams));
    }
    async getCollateralSurplusBalance(assetAddress, address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getCollateralSurplusBalance(assetAddress, address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getCollateralSurplusBalance(assetAddress, address, ...extraParams));
    }
    async getTroves(assetAddress, params, ...extraParams) {
        var _a;
        const { beforeRedistribution, ...restOfParams } = params;
        const [totalRedistributed, troves] = await Promise.all([
            beforeRedistribution ? undefined : this.getTotalRedistributed(assetAddress, ...extraParams),
            (_a = this._cache.getTroves(assetAddress, { beforeRedistribution: true, ...restOfParams }, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getTroves(assetAddress, { beforeRedistribution: true, ...restOfParams }, ...extraParams)
        ]);
        if (totalRedistributed) {
            return troves.map(trove => trove.applyRedistribution(totalRedistributed));
        }
        else {
            return troves;
        }
    }
    async getFees(assetAddress, ...extraParams) {
        var _a;
        return (_a = this._cache.getFees(assetAddress, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getFees(assetAddress, ...extraParams);
    }
    async getIsMinted(assetAddress, address, ...extraParams) {
        var _a;
        return ((_a = this._cache.getIsMinted(assetAddress, address, ...extraParams)) !== null && _a !== void 0 ? _a : this._readable.getIsMinted(assetAddress, address, ...extraParams));
    }
}
exports._CachedReadableLiquity = _CachedReadableLiquity;
//# sourceMappingURL=_CachedReadableLiquity.js.map